/**
 * useOrgDashboard hook
 *
 * Fetches aggregated dashboard metrics from /api/tenant/dashboard.
 * Returns data, loading state, and error.
 */

"use client";

import { c as _c } from "react/compiler-runtime";
import { useApiQuery } from "@/hooks/useApiQuery";
import type { OrgDashboardData } from "@/lib/organizations/dashboard-service";
export function useOrgDashboard() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      errorMessage: "Dashboard-Daten konnten nicht geladen werden"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useApiQuery("/api/tenant/dashboard", t0);
}